/**
 * Created by zad on 17/4/25.
 */
import { NoteContent } from '../constants/actionTypes';
import createAction from '../utils/createAction';

// eslint-disable-next-line import/prefer-default-export
export const getNoteContent = createAction(NoteContent.GET_NOTE_CONTENT, 'noteId', 'isForce');

export const updateNoteContentAbbr = createAction(NoteContent.UPDATE_NOTE_CONTENT_ABBR, 'noteId', 'abbr', 'wordNum');

export const postAudio = createAction(NoteContent.POST_AUDIO, 'noteId', 'audio');

export const putAudioMessage = createAction(NoteContent.PUT_AUDIO_MESSAGE, 'noteId', 'params');

export const deleteAudio = createAction(NoteContent.DELETE_AUDIO, 'noteId');

export const getAudioUrl = createAction(NoteContent.GET_AUDIO_URL, 'noteId');



// WEBPACK FOOTER //
// ./src/actions/NoteContentAction.js